export const MAX_API_KEYS = 2;

export type ApiKey = {
    id: string;
    userId: string;
    keyHash: string;
    name: string;
    lastUsed: Date | null;
    created: Date;
    updated: Date;
};
